export const msalConfig = {
    auth: {
      clientId: process.env.REACT_APP_CLIENT_ID_ENTRA,  
      authority: process.env.REACT_APP_AUTHORITY,
      redirectUri: `${window.location.origin}/dashboard`,
      navigateToLoginRequestUrl: false
    }
  };
  export const loginRequest = {
    scopes: ["openid", "offline_access"], 
  };

  export const profileRequest = {
    scopes: ["https://YOUR_TENANT_NAME.onmicrosoft.com/api/read"],
  };
  